import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class ProductFamilyContributorModel extends Model {
  @attr('number') position;
  @attr('boolean') isMainContributor;

  // Relation
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('category', { async: true, inverse: null }) category;
  @belongsTo('product-family', { async: true, inverse: 'contributors' })
  productFamily;
}
